import type { NextPageContext } from 'next';

import { Item } from 'types';
import { getCategoryFromSlug, getCollection, getMarketingCopy } from '@root/server/services/Collection';
import productCategories, { CategoryDto } from 'components/Collection/pages/categories';
import CollectionCategoryPageComponent, { MarketingCopy } from 'components/Collection/pages/category';
import { withPageStaticProps } from 'utils/header';

type CollectionCategoryPageProps = {
  activeCategory: CategoryDto;
  marketingCopy?: MarketingCopy;
  products: Item[];
};

export const CollectionCategoryPage = ({ activeCategory, products, marketingCopy }: CollectionCategoryPageProps) => (
  <CollectionCategoryPageComponent activeCategory={activeCategory} products={products} marketingCopy={marketingCopy} />
);

// This function gets called at build time
export const getStaticPaths = async () => {
  const categories = productCategories.filter((c) => c.slug !== null);

  const paths = categories.map((c) => ({
    params: {
      category: c.slug,
    },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
};

type Context = NextPageContext & {
  params: {
    category: string;
  };
};

export const getStaticProps = withPageStaticProps(async ({ params }: Context) => {
  const { category } = params;
  const productCategory = getCategoryFromSlug(category);
  const collectionSlug = category === 'tuxedos-and-suits' ? 'collection' : `collection/${category}`;

  return {
    props: {
      activeCategory: {
        displayName: productCategory!.displayName,
        name: productCategory!.name,
        slug: category,
      },
      products: await getCollection(productCategory!.name),
      marketingCopy: await getMarketingCopy(collectionSlug),
    },
  };
});

export default CollectionCategoryPage;
